<template lang="pug">
.v-field-tabs.field-tabs(v-if="field")
	label.field-tabs__label.field-label(v-if="field.label") {{field.label}}
	.field-tabs__items
		component.field-tabs__item(v-for="option in field.options" type="button" :is="option.link ? 'a' : 'button'" :href="option.link" @click="option.link ? null : localValue = option.value; handlerInput();" :class="[localValue === option.value || option.active ? 'active' : '']")
			span.field-tabs__item-text(v-if="option.text") {{option.text}}
			span.field-tabs__item-count(v-if="option.count") {{option.count}}
			v-svg-icon.field-tabs__item-icon(v-if="option.svg" :icon="option.svg")
			img.field-tabs__item-icon(v-else-if="option.icon" :src="option.icon")
</template>

<script>

export default {

	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [String, Number],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],
	
	data() {
		return {
			localValue: null,
			open: false,
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handlerInput() {
			this.$emit('update:model-value', this.localValue, this.field);
		}
	}
};
</script>
